import { lookupCard } from "../../content/index.js";
import { actionDraw } from "../deck/actionDraw.js";
import type { ApplyEffectContext } from "./effectContext.js";

function drawToHand(ctx: ApplyEffectContext, count: number): ApplyEffectContext {
  const result = actionDraw(ctx.run, count);
  return {
    ...ctx,
    reshuffled: ctx.reshuffled || result.reshuffled,
    run: {
      ...result.run,
      deck: result.deck,
      discard: result.discard,
      rngState: result.rngState,
      hand: [...ctx.run.hand, ...result.drawn],
    },
  };
}

function drawPerType(
  ctx: ApplyEffectContext,
  type: "worker" | "action",
): ApplyEffectContext {
  const count = ctx.run.hand.filter((card) => lookupCard(card.cardId)?.type === type).length;
  return count > 0 ? drawToHand(ctx, count) : ctx;
}

export function applyDrawPerWorker(ctx: ApplyEffectContext): ApplyEffectContext {
  return drawPerType(ctx, "worker");
}

export function applyDrawPerAction(ctx: ApplyEffectContext): ApplyEffectContext {
  return drawPerType(ctx, "action");
}
